module.exports = __webpack_public_path__ + "img/c4.164d52eb.png";